import { Observable } from 'rxjs';

declare global {
  interface Window {
    API?: ScormApiInterface;
  }
}

export interface ScormInterface {
  LMSInitialize(): 'true' | 'false';
  LMSFinish(): 'true' | 'false';
  LMSGetValue(parameter: string): 'false' | string;
  LMSSetValue(parameter: string, value: string): 'true' | 'false';
  LMSCommit(): string;
  LMSGetLastError(): ScormErrorCodes;
  LMSGetErrorString(code: string): string;
  LMSGetDiagnostic(): string;
}

export interface ScormApiInterface extends ScormInterface {
  lastErrorCode: ScormErrorCodes;
  lastDiagnosticMessage: string;
  hasCalledLMSFinish: boolean;
  mode: ScormCmiMode;
  eduContentId?: number | null;
  commit$: Observable<string>;
  cmi$: Observable<string>;
  setCurrentCMI(str: string): void;
}

export enum ScormErrorCodes {
  NO_ERROR = '0',
  GENERAL_ERROR = '101',
  INVALID_ARGUMENT_ERROR = '201',
  ELEMENT_CANNOT_HAVE_CHILDREN_ERROR = '202',
  ELEMENT_CANNOT_HAVE_COUNT_ERROR = '203',
  NOT_INITIALIZED_ERROR = '301',
  NOT_IMPLEMENTED_ERROR = '401',
  INVALID_SET_VALUE_ELEMENT_IS_KEYWORD_ERROR = '402',
  READ_ONLY_ERROR = '403',
  WRITE_ONLY_ERROR = '404',
  INCORRECT_DATA_TYPE_ERROR = '405',
}

export enum ScormCmiMode {
  CMI_MODE_NORMAL = 'normal',
  CMI_MODE_BROWSE = 'browse',
  CMI_MODE_REVIEW = 'review',
  CMI_MODE_PREVIEW = 'preview',
  CMI_MODE_GRADING = 'grading',
}

export enum ScormStatus {
  STATUS_INCOMPLETE = 'incomplete',
  STATUS_COMPLETED = 'completed',
  STATUS_PASSED = 'passed',
  STATUS_FAILED = 'failed',
  STATUS_BROWSED = 'browsed',
  STATUS_NOT_ATTEMPTED = 'not attempted',
}

export namespace ScormStatus {
  export function isCompleted(status: ScormStatus): boolean {
    return [
      ScormStatus.STATUS_COMPLETED,
      ScormStatus.STATUS_BROWSED,
      ScormStatus.STATUS_PASSED,
      ScormStatus.STATUS_FAILED,
    ].includes(status);
  }
}

export interface ScormCmiInterface {
  mode: ScormCmiMode;
  core: {
    score: {
      raw: number | string; // SCORM 1.2 expects all values as strings
      min?: number | string; //undefined
      max?: number | string; //undefined
    };
    lesson_mode?: ScormCmiMode; // SCORM 1.2 compatibility, but should be the same as mode
    lesson_location?: string; //''
    lesson_status: ScormStatus;
    total_time: string; //'0000:00:00'
    session_time?: string; //'0000:00:00'
    entry?: 'ab-initio' | 'resume'; // SCORM 1.2 compatibility, but should be 'resume' when resuming an exercise and 'ab-initio' when starting fresh
  };
  objectives?: any;
  suspend_data?: any;
}
